export default "__VITE_ASSET__BfBsqFHh__"